import React from 'react';
import type { LineShape as LineShapeType } from '../../types';
import { lineHitPolygon } from '../../utils/hitArea';

interface LineShapeProps {
  shape: LineShapeType;
  isEditor?: boolean;
  isSelected?: boolean;
}

export const LineShape = React.memo(function LineShape({
  shape,
  isEditor,
  isSelected,
}: LineShapeProps) {
  return (
    <g data-shape-id={shape.id}>
      {isEditor && (
        <polygon
          points={lineHitPolygon(shape.x1, shape.y1, shape.x2, shape.y2, 0.015)}
          fill="transparent"
          stroke="none"
          pointerEvents="fill"
          style={{ cursor: 'inherit' }}
        />
      )}
      <line
        x1={shape.x1}
        y1={shape.y1}
        x2={shape.x2}
        y2={shape.y2}
        stroke={shape.color}
        strokeWidth={2}
        vectorEffect="non-scaling-stroke"
        pointerEvents="none"
      />
    </g>
  );
});
